<!--  -->
<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb :canBackHistory="true"></breadcrumb>
        </div>
        <div class="search-ctn" style="min-height: 0">
            <div class="search-ctn-right">
                <div class="search-name">操作对象</div>
                <el-select class="search-item" size="small" v-model="searchData.OpObject" filterable clearable>
                    <el-option key="全部" label="全部" value=""></el-option>
                    <el-option v-for="(item,index) in opObjList" :key="index" :label="item.TValue" :value="item.TKey"></el-option>
                </el-select>
                <div class="search-name">操作类型</div>
                <el-select class="search-item" size="small" v-model="searchData.OpType" filterable clearable>
                    <el-option key="全部" label="全部" value=""></el-option>
                    <el-option v-for="(item,index) in opTypeList" :key="index" :label="item.TValue" :value="item.TKey"></el-option>
                </el-select>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询 (Enter)</el-button>
                <el-button size="small" class="search-btn btn-primary" @click="showSearchDialog">更多条件（F2）</el-button>
            </div>
        </div>
        <div class="table-ctn">
            <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" border="" style="width: 100%" v-loading="loading">
                <el-table-column width="180px" prop="OpObjectName" label="操作对象" show-overflow-tooltip></el-table-column>
                <el-table-column width="180px" prop="OpTypeName" label="操作类型" show-overflow-tooltip></el-table-column>
                <el-table-column width="100px" prop="Oper" label="操作人" show-overflow-tooltip></el-table-column>
                <el-table-column prop="Remark" label="操作内容" show-overflow-tooltip></el-table-column>
                <el-table-column width="180px" prop="CreateTime" label="创建时间"></el-table-column>
            </el-table>
        </div>
        <div class="pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
        <el-dialog
            :close-on-click-modal="false"
            title="系统操作日志搜索"
            :visible.sync="dialogVisible"
            width="400px"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="search-syslogs-dialog"
            custom-class="search-item-dialog"
            style="margin-left: -170px"
        >
            <div class="dialog-content" v-if="dialogVisible">
                <el-form ref="form" label-position="left" label-width="70px">
                    <el-form-item label="操作人">
                        <el-select v-model="searchData.OperaterId" class="search-item" style="width: 100%" size="small" filterable clearable placeholder="请选择">
                            <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="操作内容">
                        <el-input class="search-item" style="width: 100%" size="small" v-model="searchData.Remark" placeholder="请输入单号或其他"></el-input>
                    </el-form-item>
                    <el-form-item label="操作日期">
                        <el-date-picker
                            size="small"
                            style="width: 100%"
                            v-model="datetime"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            @change="onDateTimeSelect"
                        ></el-date-picker>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer">
                    <el-button class="btn-primary" size="small" @click="handleSearch">查询（Enter）</el-button>
                    <el-button size="small" @click="resetSearch">重置</el-button>
                    <el-button size="small" @click="closeSearchDialog">关闭（Esc）</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import mixin from '@/mixins/mixin';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    name: '',
    components: {
        breadcrumb
    },
    data() {
        return {
            isStopReq: false,
            loading: false,
            datetime: [],
            searchData: {
                OpType: '',
                OpObject: '',
                OperaterId: '',
                Remark: '',
                StartDate: '',
                EndDate: '',
                page: 1,
                limit: this.commonPageSize
            },
            isUseSE: false,
            dialogVisible: false,
            SIdList: [],
            tableData: [],
            tableDataLength: 0,
            opTypeList: [],
            opObjList: [],
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ],
                disabledDate(time) {
                    const year = new Date().getFullYear(); // 获取当前年份
                    const mon = new Date().getMonth() + 1; // 获取当前月份份
                    const day = new Date().getDate(); // 获取当前日期
                    const oneYear = year - 1; // 获取去年
                    const timeYear = new Date(oneYear + '/' + mon + '/' + day).getTime(); // 将的日期转换成时间戳
                    return time.getTime() > Date.now() || time.getTime() <= timeYear;
                }
            }
        };
    },
    beforeRouteLeave(to, from, next) {
        document.removeEventListener('keydown', this.handleKeyEvent);
        next();
    },
    created() {
        document.addEventListener('keydown', this.handleKeyEvent);
        this.getOpTypeData();
        this.getOpObjData();

        //当前设定的日期时间
        let d = new Date();
        let year1, month1, day1;
        [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()];
        let date1 = new Date(year1, month1, day1, 0);
        this.datetime.push(date1);

        //前一天设定的日期时间
        let year2, month2, day2;
        d.setTime(d.getTime());
        [year2, month2, day2] = [d.getFullYear(), d.getMonth(), d.getDate()];
        let date2 = new Date(year2, month2, day2, 0);
        this.datetime.unshift(date2);

        this.searchData.StartDate = date2;
        this.searchData.EndDate = date1;
    },
    mounted() {
        this.getConfigByCodes().then(() => {
            this.getTableData();
        });
        this.getSIdList();
    },
    methods: {
        handleKeyEvent(e) {
            let key = window.event.keyCode;
            let that = this;
            if (key === 113) {
                that.dialogVisible = true;
            }
            if (key === 27) {
                if (that.dialogVisible) that.dialogVisible = false;
            }
            if (key === 13) {
                that.handleSearch();
                return;
            }
            //左键
            if (key == 37) {
                if (this.searchData.page > 1) {
                    this.searchData.page -= 1;
                    this.getTableData();
                }
                return;
            }
            //右键
            if (key == 39) {
                if (this.searchData.page < Math.ceil(this.tableDataLength / this.searchData.limit)) {
                    this.searchData.page += 1;
                    this.getTableData();
                }
                return;
            }
        },
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = ['czrzsyssyq'];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            let rValue = data[i].RValue;
                            switch (code) {
                                case 'czrzsyssyq': //使用搜索引擎配置
                                    this.isUseSE = result;
                                    break;
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        resetSearch() {
            this.searchData = {
                OpType: '',
                OpObject: '',
                OperaterId: '',
                Remark: '',
                StartDate: '',
                EndDate: '',
                page: 1,
                limit: this.commonPageSize
            };
            this.datetime = [];
        },
        getTableData() {
            if (!this.isStopReq) {
                if (!this.isUseSE && (!this.searchData.StartDate || !this.searchData.EndDate)) {
                    this.$util.warningMsg('请选择时间区间进行查询');
                    return;
                }
                this.loading = true;
                this.isStopReq = true;
                let url = '';
                if (this.isUseSE) url = '/api/EntpInfoManagement/GetEntpOpLogBySearchEngine';
                else url = '/api/EntpInfoManagement/GetEntpOpLogData';
                this.$util
                    .axiosGet({
                        url: url,
                        data: this.searchData,
                        hideLoading: true
                    })
                    .then(res => {
                        let data = res.data;
                        if (!data) data = [];
                        this.tableData = data;
                        if (this.isUseSE) this.tableDataLength = res.count;
                    })
                    .catch(() => {})
                    .finally(() => {
                        this.loading = false;
                        this.isStopReq = false;
                    });
                if (!this.isUseSE && this.searchData.page == 1) this.getTableDataCount();
            }
        },
        getTableDataCount() {
            this.$util
                .axiosGet({
                    url: '/api/EntpInfoManagement/GetEntpOpLogDataCount',
                    data: this.searchData,
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = 0;
                    this.tableDataLength = data;
                })
                .catch(() => {})
                .finally(() => {
                    this.loading = false;
                    this.isStopReq = false;
                });
        },
        getOpTypeData() {
            this.$util.getConfigData('OpType').then(res => {
                this.opTypeList = res;
            });
        },
        getOpObjData() {
            this.$util.getConfigData('OpObject').then(res => {
                this.opObjList = res;
            });
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        //选中时间
        onDateTimeSelect(val) {
            if (val != null) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        getSIdList() {
            this.$util.getSIdList().then(data => {
                this.SIdList = data;
            });
        },
        closeSearchDialog() {
            this.dialogVisible = false;
        },
        showSearchDialog() {
            this.dialogVisible = true;
        }
    }
};
</script>
<style lang="less">
#search-syslogs-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;
    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }
    .search-item-dialog {
        width: 340px;
        height: auto;
        .dialog-footer {
            text-align: right;
        }
        .el-form-item {
            margin-bottom: 0;
        }
    }
    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}
</style>
